import Breadcrumbs from "e.sic-platform.webclient/src/components/navbar/Breadcrumbs";
import LanguageSelector from "e.sic-platform.webclient/src/components/navbar/LanguageSelector";
import {
  NavbarActions,
  NavbarMain,
} from "e.sic-platform.webclient/src/components/navbar/NavbarComponents";
import { authentication } from "e.sic-platform.webclient/src/services/authentication/Authentication";
import { observer } from "mobx-react-lite";
import { useCallback, useMemo } from "react";
import CoinBalance from "./CoinBalance";
import ProfileButton from "e.sic-platform.webclient/src/components/navbar/ProfileButton";
import { MenuItem, Divider, Box } from "@mui/material";
import { translationService } from "e.sic-platform.webclient/src/services/translation/TranslationService";
import BreadcrumbItem from "e.sic-platform.webclient/src/components/navbar/BreadcrumbItem";
import { creditBalanceStorage } from "e.sic-platform.webclient/src/services/shop/CreditBalanceStorage";
import UserTag from "./UserTag";
import NavbarMenu from "./NavbarMenu";
import useMenuStorage from "../../services/menu/MenuStorageService";
import { useNavigate } from "react-router-dom";

export default observer(function Navbar(props: { menuOpen: boolean; setMenuOpen: (menuOpen: boolean) => void }) {
  const navigate = useNavigate();
  const {menuCategories} = useMenuStorage();

  const logoutFunction = useCallback(() => {
    authentication.logout();
  }, [authentication]);

  const goToMyAccount = useCallback(() => {
    navigate("/my-account");
  }, []);

  const goToHistory = useCallback(() => {
    navigate("/app-usage");
  }, []);

  const goToOrders = useCallback(async () => {
    var link = await creditBalanceStorage.getCustomerPortalSessionLink();
    window.location.href = link;
  }, [creditBalanceStorage]);

  return (
    <NavbarMain>
      <Box display="flex" alignItems="center">
        <NavbarMenu menuOpen={props.menuOpen} setMenuOpen={props.setMenuOpen} />
        <Breadcrumbs menuCategories={menuCategories} title={"SmartApps"} />
      </Box>

      <NavbarActions>
        <BreadcrumbItem to="/shop" textKey="general.shop" />
        <CoinBalance />
        <Divider
          orientation="vertical"
          sx={{ mr: 2, p: 0, borderColor: "white" }}
          flexItem
        />
        <LanguageSelector />
        <Divider
          orientation="vertical"
          sx={{ mr: 2, p: 0, borderColor: "white" }}
          flexItem
        />
        <UserTag />
        <ProfileButton logoutFunction={logoutFunction}>
          <MenuItem onClick={goToMyAccount}>
            {translationService.translate("general.my-account")}
          </MenuItem>
          <MenuItem onClick={goToHistory}>
            {translationService.translate("general.shop.history")}
          </MenuItem>
          <MenuItem onClick={goToOrders}>
            {translationService.translate("general.shop.orders")}
          </MenuItem>
        </ProfileButton>
      </NavbarActions>
    </NavbarMain>
  );
});
